module.exports = __webpack_public_path__ + "static/media/Ensure-Family.101aa16f.png";